import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import classNames from 'classnames';
import { CaretDownIcon } from '@radix-ui/react-icons';
import './NavbarStyles.css';
import { forwardRef } from 'react';
import { useLogout } from '../hooks/useLogout';
import { useAuthContext } from '../hooks/useAuthContext';
import NavbarLogo from './NavbarLogo';

const NavigationMenuDemo = () => {
  const { logout } = useLogout()
  const { user } = useAuthContext()
  return ( 
    <nav className="navbar navbar-expand-sm navbar-light bg-white fixed-top border-bottom ">
    <NavigationMenu.Root className="NavigationMenuRoot">
      <NavigationMenu.List className="NavigationMenuList">
        
        <NavigationMenu.Item color>
          <NavigationMenu.Trigger className="NavigationMenuTrigger">
            Interstices <CaretDownIcon className="CaretDown" aria-hidden />
          </NavigationMenu.Trigger>
          <NavigationMenu.Content className="NavigationMenuContent">
            <ul className="List one">
              <li style={{ gridRow: 'span 3' }}>
                <NavigationMenu.Link asChild>
                  <a className="Callout" href="/">
                    <NavbarLogo />
                  </a>
                </NavigationMenu.Link>
              </li>

              <ListItem href="/vision" title="Vision">
                <ul>
                  <li></li>
                </ul>
              </ListItem>
              <ListItem href="/philosophy" title="Philosophy">
                <ul>
                  <li></li>
                </ul>
              </ListItem>
              <ListItem href="/history" title="History">
                <ul>
                  <li></li>
                </ul>
              </ListItem>
            </ul>
          </NavigationMenu.Content>
        </NavigationMenu.Item>

        <NavigationMenu.Item>
          <NavigationMenu.Trigger className="NavigationMenuTrigger">
          Interactions <CaretDownIcon className="CaretDown" aria-hidden />
          </NavigationMenu.Trigger>
          <NavigationMenu.Content className="NavigationMenuContent">
            <ul className="List one">
              <li style={{ gridRow: 'span 3' }}>
                <NavigationMenu.Link asChild>
                  <a className="Callout" href="/">
                    <NavbarLogo />
                  </a>
                </NavigationMenu.Link>
              </li>

              <ListItem href="/events" title="Current Events">
                <ul>
                  <li>2024-2026</li>
                </ul>
              </ListItem>
              <ListItem href="/eventspast" title="Past Events">
                <ul>
                  <li>Collaboration FIND/FAD 2015-2023</li>
                </ul>
              </ListItem>
            </ul>
          </NavigationMenu.Content>
        </NavigationMenu.Item>

        <NavigationMenu.Item>
          <NavigationMenu.Trigger className="NavigationMenuTrigger">
          Publications <CaretDownIcon className="CaretDown" aria-hidden />
          </NavigationMenu.Trigger>
          <NavigationMenu.Content className="NavigationMenuContent">
            <ul className="List one">
              <li style={{ gridRow: 'span 3' }}>
                <NavigationMenu.Link asChild>
                  <a className="Callout" href="/">
                    <NavbarLogo />
                  </a>
                </NavigationMenu.Link>
              </li>

              <ListItem href="/transversalpaths" title="Transversal Paths">
                <ul>
                  <li>Online review</li>
                </ul>
              </ListItem>
              
            </ul>
          </NavigationMenu.Content>
        </NavigationMenu.Item>

        <NavigationMenu.Item>
          <NavigationMenu.Trigger className="NavigationMenuTrigger">
            About <CaretDownIcon className="CaretDown" aria-hidden />
          </NavigationMenu.Trigger>
          <NavigationMenu.Content className="NavigationMenuContent">
            <ul className="List one">
              <li style={{ gridRow: 'span 4' }}>
                <NavigationMenu.Link asChild>
                  <a className="Callout" href="/">
                    <NavbarLogo />
                  </a>
                </NavigationMenu.Link>
              </li>

              <ListItem href="/organization" title="Organization">
                <ul>
                  <li>Dr. Adrián Navigante</li>
                  <li>Dr. Amanda Viana</li>
                </ul>
              </ListItem>
              <ListItem href="/collaborators" title="Collaborators">
                <ul>
                  <li>Dr. Anand Mishra</li>
                  <li>Dr. Sarah Eichner</li>
                  <li>Valerio Lucia</li>
                </ul>
              </ListItem>
              <ListItem href="/address" title="Contact">
                <ul>
                  <li>Address </li>
                </ul>
              </ListItem>
              {!user && 
              <ListItem href="/login" title="Sign in">
              </ListItem>
              }
              {user && (
                <button className="btn btn-outline-danger btn-sm" onClick={logout}>logout</button>
              )}
            </ul>
          </NavigationMenu.Content>
        </NavigationMenu.Item>

        <NavigationMenu.Indicator className="NavigationMenuIndicator">
          <div className="Arrow" />
        </NavigationMenu.Indicator>
      </NavigationMenu.List>

      <div className="ViewportPosition">
        <NavigationMenu.Viewport className="NavigationMenuViewport" />
      </div>
    </NavigationMenu.Root>
    </nav>
  );
};

const ListItem = forwardRef(({ className, children, title, ...props }, forwardedRef) => (
  <li>
    <NavigationMenu.Link asChild>
      <a className={classNames('ListItemLink', className)} {...props} ref={forwardedRef}>
        <div className="ListItemHeading">{title}</div>
        <p className="ListItemText">{children}</p>
      </a>
    </NavigationMenu.Link>
  </li>
));

export default NavigationMenuDemo;